import { authApi } from "../../utils/axios";

export const getOrganisations = async (params = {}, onSuccess, onFail) => {
  try {
    const response = await authApi({
      method: "GET",
      url: "/organisations",
      params: params,
    });

    if (params.append) {
      response.data.append = params.append;
    }

    if (onSuccess) {
      onSuccess(response.data);
    }
    return response.data;
  } catch (error) {
    if (onFail) {
      onFail(error);
    }
    throw error;
  }
};

export const createOrganisation = async (
  organisationData,
  onSuccess,
  onFail
) => {
  try {
    const response = await authApi({
      method: "POST",
      url: "/organisations",
      data: organisationData,
    });

    if (onSuccess) {
      onSuccess(response.data);
    }
    return response.data;
  } catch (error) {
    if (onFail) {
      onFail(error);
    }
    throw error;
  }
};

export const getOrganisationById = async (id, onSuccess, onFail) => {
  try {
    const response = await authApi({
      method: "GET",
      url: `/organisations/${id}`,
    });

    if (onSuccess) {
      onSuccess(response.data);
    }
    return response.data;
  } catch (error) {
    if (onFail) {
      onFail(error);
    }
    throw error;
  }
};

export const updateOrganisation = async (id, updateData, onSuccess, onFail) => {
  try {
    const response = await authApi({
      method: "PATCH",
      url: `/organisations/${id}`,
      data: updateData,
    });

    if (onSuccess) {
      onSuccess(response.data);
    }
    return response.data;
  } catch (error) {
    if (onFail) {
      onFail(error);
    }
    throw error;
  }
};

export const deleteOrganisation = async (id, onSuccess, onFail) => {
  try {
    const response = await authApi({
      method: "DELETE",
      url: `/organisations/${id}`,
    });

    if (onSuccess) {
      onSuccess(response.data);
    }
    return response.data;
  } catch (error) {
    if (onFail) {
      onFail(error);
    }
    throw error;
  }
};

export const updateSelectedOrganisation = async (id) => {
  try {
    const response = await authApi({
      method: "PUT",
      url: `/organisations/${id}/select`,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getSelectedOrganisation = async () => {
  try {
    const response = await authApi({
      method: "GET",
      url: "/organisations/selected",
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
